
export default {
	components: {
		vcDynamicLink		: () => import('../../components/pages/dynamic-link.vue')
	}
}
